export default __webpack_public_path__ + "static/media/logo_govoice_h@2x.83a9cdd8.png";